import {
  formatMoney,
  itemPriceParts,
  itemWhatsappText,
  localeOf,
  SHARE_TOKEN_PATTERN,
  whatsappLinks,
  type PublicItem,
} from "@fusiqo/vozqi-shared";

/**
 * What the public share page computes, as plain functions (spec compartir
 * producto §7): the page itself only draws.
 */

/** `/p/<token>` → the token, when it has the shape one has; anything else is null. */
export function tokenFromPath(pathname: string): string | null {
  const match = /^\/p\/([^/]+)\/?$/.exec(pathname);
  const token = match?.[1];
  return token !== undefined && SHARE_TOKEN_PATTERN.test(token) ? token : null;
}

/**
 * The «Escribir por WhatsApp» button's link, to the business's own number,
 * with the message the phone sends too (`itemWhatsappText`). Null without a
 * number: the page does not draw the button.
 */
export function whatsappHref(view: PublicItem, variantName: string | null): string | null {
  if (view.business.whatsapp === null) return null;
  return whatsappLinks(view.business.whatsapp, itemWhatsappText(view, variantName)).web;
}

/** «Desde B/. 12.00 · unidad»: `itemPriceParts` in one line, for a screen reader. */
export function priceLabel(view: PublicItem, chosen: number | null): string {
  const { from, price, unit } = itemPriceParts(view, chosen);
  const amount = from ? `Desde ${price}` : price;
  return unit === null ? amount : `${amount} · ${unit}`;
}

/** One variant's own price, on its option. */
export function variantPrice(view: PublicItem, index: number): string {
  const variant = view.item.variants[index];
  return variant === undefined ? "" : formatMoney(variant.priceCents, localeOf(view.business.country));
}
